import { render, staticRenderFns } from "./inventory-lot-details.html?vue&type=template&id=4c90de8d&scoped=true&"
import script from "./inventory-lot-details.ts?vue&type=script&lang=js&"
export * from "./inventory-lot-details.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90de8d",
  null
  
)

export default component.exports